/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Box, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useDateFormat, useTimeFormat} from '@enisco/mcc-react-lib'
import {SxProps} from '@mui/system'

interface Props {
  sx?: SxProps
}

const Clock: React.FC<Props> = ({sx}) => {
  const [currentTime, setCurrentTime] = useState(new Date())
  const timeFormat = useTimeFormat()
  const dateFormat = useDateFormat()

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <Box sx={sx}>
      <Typography
        sx={{textAlign: 'center', color: 'text.primary'}}
        variant={'h6'}
      >
        {timeFormat(currentTime)}
      </Typography>
      <Typography
        sx={{textAlign: 'center', color: 'text.primary'}}
        variant={'body2'}
      >
        {dateFormat(currentTime)}
      </Typography>
    </Box>
  )
}

export default Clock
